<button type="button" class="btn primary" [disabled]="disabled" (click)="stepper.next(); click.next($event)">
  {{ 'COMMON.NEXT' | translate }}
</button>
